import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { BsCheckCircle } from '@react-icons/all-files/bs/BsCheckCircle';
import { BsChevronDoubleUp } from '@react-icons/all-files/bs/BsChevronDoubleUp';
import { LinkContainer } from 'react-router-bootstrap';
import { Enums } from '../Utils/Enums';
import { Tooltip } from './Tooltip';

export interface ISoftwareUpdateAlertProps {
    readonly updateStatus: Mri.DisplaySoftware.DisplaySoftwareUpdateStatus | undefined;
    readonly className?: string;
}

@observer
export class SoftwareUpdateAlert extends React.Component<ISoftwareUpdateAlertProps> {
    public render() {
        const { className, updateStatus } = this.props;

        if (this.show)
            return (
                <Tooltip message={this.message}>
                    <LinkContainer
                        to={'/software-updates/manifests/' + updateStatus?.softwareUpdateManifestGuid + '/status'}
                        className="p-0 btn btn-link"
                    >
                        <span>
                            {updateStatus && updateStatus.state == Mri.DisplaySoftware.SoftwareUpdateState.Updated && (
                                <BsCheckCircle className={this.color + ' ' + className} />
                            )}
                            {updateStatus && updateStatus.state != Mri.DisplaySoftware.SoftwareUpdateState.Updated && (
                                <BsChevronDoubleUp className={this.color + ' ' + className} />
                            )}
                        </span>
                    </LinkContainer>
                </Tooltip>
            );
        else return null;
    }

    @computed
    private get show() {
        const { updateStatus } = this.props;

        return (
            updateStatus != null &&
            updateStatus.state != Mri.DisplaySoftware.SoftwareUpdateState.Idle &&
            updateStatus.state != Mri.DisplaySoftware.SoftwareUpdateState.NoConnection
        );
    }

    @computed
    private get color() {
        const { updateStatus } = this.props;

        if (updateStatus && updateStatus.state == Mri.DisplaySoftware.SoftwareUpdateState.Error) {
            return 'text-danger';
        } else if (updateStatus && updateStatus.state == Mri.DisplaySoftware.SoftwareUpdateState.Pending) {
            return 'text-warning';
        } else if (updateStatus && updateStatus.state == Mri.DisplaySoftware.SoftwareUpdateState.Updating) {
            return 'text-running text-pulse';
        } else if (updateStatus && updateStatus.state == Mri.DisplaySoftware.SoftwareUpdateState.UpdatingSlave) {
            return 'text-running text-pulse';
        } else if (updateStatus && updateStatus.state == Mri.DisplaySoftware.SoftwareUpdateState.Idle) {
            return 'text-purple';
        } else if (updateStatus && updateStatus.state == Mri.DisplaySoftware.SoftwareUpdateState.NoConnection) {
            return 'text-purple';
        } else if (updateStatus && updateStatus.state == Mri.DisplaySoftware.SoftwareUpdateState.Updated) {
            return 'text-success';
        } else {
            return 'd-none';
        }
    }

    @computed
    private get message() {
        const { updateStatus } = this.props;
        if (updateStatus) return `Software Update: ${Enums.toString(Enums.SoftwareUpdateState, updateStatus.state)}`;
    }
}
